const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl, ToggleControl, TextControl } = wp.components;
import SelectBackground from '../../wp-controlers/select-background';
import CommonPanel from '../../wp-controlers/common-panel';

const Inspector = ({ attributes, setAttributes }) => {
  const { padding, small, hasId, idContainer, isFlex, zIndexUp } = attributes;

  return (
    <InspectorControls>
      <PanelBody>
        <SelectBackground
          attributes={attributes}
          setAttributes={setAttributes}
        />

        <ToggleControl
          label="Utilizar container menor?"
          checked={small}
          onChange={() => setAttributes({ small: !small })}
        />

        <SelectControl
          label="Padding deste container"
          title="Padding deste container"
          value={padding}
          options={[
            { label: 'Nenhum', value: 'none' },
            { label: 'Pequeno', value: 'small' },
            { label: 'Médio', value: 'medium' },
            { label: 'Grande', value: 'large' },
          ]}
          onChange={(position) => setAttributes({ padding: position })}
        />

        <ToggleControl
          label="Adicionar id ao container?"
          checked={hasId}
          onChange={() => setAttributes({ hasId: !hasId })}
        />

        {hasId && (
          <TextControl
            label="Informe o ID do container"
            value={idContainer}
            onChange={(idContainer) => setAttributes({ idContainer })}
          />
        )}

        <ToggleControl
          label="Alinhar elementos na vertical em mobile e na horizontal em desktop"
          checked={isFlex}
          onChange={() => setAttributes({ isFlex: !isFlex })}
        />

        <ToggleControl
          label="O container tem conteudo que sobrepoem outras seções(por exemplo um modal)"
          checked={zIndexUp}
          onChange={() => setAttributes({ zIndexUp: !zIndexUp })}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;